y<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    :color="color"
    :outlined="secondaryButton"
    :text="tertiaryButton"
    :aria-label="ariaLabel"
  >
    <slot>
      <v-icon
        v-if="icon"
        :class="{'material-icons-outlined':iconOutlined}"
      >
        {{ icon }}
      </v-icon>
      <span
        v-if="transition"
        :class="icon ? 'pl-2' : 'pl-0'"
      >
        <transition
          :mode="transitionMode"
          :name="transitionName"
        >
          <span
            :key="buttonText"
            class="buttonText"
          >
            {{ buttonText }}
          </span>
        </transition>
      </span>
      <span
        v-else
        :class="icon ? 'pl-2 buttonText' : 'pl-0 buttonText'"
      >
        {{ buttonText }}
      </span>
    </slot>

    <template v-slot:loader>
      <slot name="loader" />
    </template>
  </v-btn>
</template>
<script>

export default {
  name: 'AdsButton',
  props: {
    ariaLabel: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: 'Button'
    },
    color: {
      type: String,
      default: 'primary'   // override the default value 'undefined' in v-btn
    },
    icon: {
      type: String,
      default: null
    },
    iconOutlined: {
      type: Boolean,
      default: true
    },
    secondary: {
      type: Boolean,
      default: false
    },
    tertiary: {
      type: Boolean,
      default: false
    },
    transition: {
      type: Boolean,
      default: false
    },
    transitionMode: {
      type: String,
      default: null
    },
    transitionName: {
      type: String,
      default: null
    }
  },
  computed: {
    secondaryButton: function () {
      return !this.tertiary && this.secondary;
    },
    tertiaryButton: function () {
      return this.tertiary && !this.secondary;
    }
  }
}
</script>

<style lang='scss' scoped>


.theme--dark {
  .v-btn--outlined.v-btn--disabled {
    border-color: transparent;
  }
}

// v-btn a11y focus state updates
.theme--light.v-btn:not(.v-btn--text):not(.v-btn--outlined):focus:before,
.theme--light.v-btn:focus::before,
.theme--dark.v-btn:focus::before {
  opacity: 0;
}

.theme--light.v-btn.primary:not(.v-btn--text):not(.v-btn--outlined) {
  border: 3px solid transparent;
}

.theme--light.v-btn.primary:not(.v-btn--text):not(.v-btn--outlined):focus {
  border: 3px solid $ads-blue-2 !important;
  .buttonText {
    text-decoration: underline;
  }
}

.theme--light.v-btn.v-btn--outlined:focus {
  box-shadow: 0 0 0 4px $ads-navy !important;
  .buttonText {
    text-decoration: underline;
  }
}

.theme--light.v-btn.no-outline,
.theme--light.v-btn.v-btn--text {
  border: 2px solid transparent;
}

.theme--light.v-btn.no-outline:focus,
.theme--light.v-btn.v-btn--text:focus {
  border: 2px solid $ads-navy !important;
  .buttonText {
    text-decoration: underline;
  }
}

.theme--dark.v-btn.primary:not(.v-btn--text):not(.v-btn--outlined) {
  border: 3px solid transparent;
}

.theme--dark.v-btn.primary:not(.v-btn--text):not(.v-btn--outlined):focus {
  border: 3px solid $ads-white !important;
  .buttonText {
    text-decoration: underline;
  }
}

.theme--dark.v-btn.v-btn--outlined:focus {
  box-shadow: 0 0 0 4px $ads-white !important;
  background-color: $ads-navy-dark;
  color: $ads-white !important;
  .buttonText {
    text-decoration: underline;
  }
}

.theme--dark.v-btn.no-outline,
.theme--dark.v-btn.v-btn--text {
  border: 2px solid transparent;
}

.theme--dark.v-btn.no-outline:focus,
.theme--dark.v-btn.v-btn--text:focus {
  border: 2px solid $ads-navy-dark !important;
}

.v-btn.v-btn--outlined {
  border-width: 2px;
}
</style>
